import { render } from "./AppAvatar.vue?vue&type=template&id=4e64214d&ts=true"
import script from "./AppAvatar.vue?vue&type=script&lang=ts"
export * from "./AppAvatar.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__